import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { cauHinhXeBusApi } from "../../../api/bus/cauHinhXeBusApi";
import { IBaseResponeModel } from "../../../models/response/base-response";
import {
	eCauHinhXeBusActionTypeIds,
	ICauHinhXeBusDeleteStart,
	ICauHinhXeBusLoadStart,
	ICauHinhXeBusSaveStart
} from "../../action-types/bus/ICauHinhXeBusActionTypes";
import { cauHinhXeBusActions } from "../../actions/bus/cauHinhXeBusActions";

export function* cauHinhXeBusSaga(): any {
	yield takeLatest(eCauHinhXeBusActionTypeIds.LOAD_START, loadCauHinhXeBusWorker)
	yield takeEvery(eCauHinhXeBusActionTypeIds.DELETE_START, deleteCauHinhXeBusWorker)
	yield takeEvery(eCauHinhXeBusActionTypeIds.SAVE_START, saveCauHinhXeBusWorker)
}
function* loadCauHinhXeBusWorker(action: ICauHinhXeBusLoadStart): any {
	const res: IBaseResponeModel = yield call([cauHinhXeBusApi, cauHinhXeBusApi.SelectByCoSo], action.payload)
	if (res.is_success) {
		yield put(cauHinhXeBusActions.loadCauHinhXeBusSuccess(res.data || []))
	} else {
		yield put(cauHinhXeBusActions.loadCauHinhXeBusError(res.message || "Không tải được cấu hình xe bus"))
	}
}
function* deleteCauHinhXeBusWorker(action: ICauHinhXeBusDeleteStart): any {
	const res: IBaseResponeModel = yield call([cauHinhXeBusApi, cauHinhXeBusApi.Delete], action.payload)
	if (res.is_success) {
		yield put(cauHinhXeBusActions.deleteCauHinhXeBusSuccess())
	} else {
		yield put(cauHinhXeBusActions.deleteCauHinhXeBusErr(res.message || "Không xoá được cấu hình xe bus"))
	}
}
function* saveCauHinhXeBusWorker(action: ICauHinhXeBusSaveStart): any {
	let res: IBaseResponeModel;
	if (action.payload.id > 0) {
		res = yield call([cauHinhXeBusApi, cauHinhXeBusApi.Update], action.payload);
	} else {
		res = yield call([cauHinhXeBusApi, cauHinhXeBusApi.Insert], action.payload);
	}
	if (res.is_success) {
		yield put(cauHinhXeBusActions.saveCauHinhXeBusSuccess())
	} else {
		yield put(cauHinhXeBusActions.saveCauHinhXeBusError(res.message || "Không lưu được cấu hình xe bus"))
	}
}
